// @flow

import type {Language} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll} from 'ramda'
import {portfoliosActions, uiActions} from '@/store'

import ModalContents from './modal-contents'

type Props = {
  startDate: any,
  endDate: any,
  label: string,
  count: number,
  l: Language,
  fetchPortfolioModalEvents: (dates: Object) => void,
  showInfoModal: (component: any, props: Object) => void,
  resetModalEventsPage: () => void,
  resetModalEventsSortOptions: () => void,
  resetModalEventsData: () => void,
  id?: string,
}

const resetModalOptions = (props) => () => {
  props.resetModalEventsPage()
  props.resetModalEventsSortOptions()
  props.resetModalEventsData()
}

const RawCounterBox = (props: Props) =>
  <div className="text-center">
    <label>{props.l(props.label)}</label>
    <a id={props.id} className="count-box" onClick={() => {
      props.fetchPortfolioModalEvents({
        startDate: props.startDate,
        endDate: props.endDate,
      })
      props.showInfoModal(ModalContents, {
        title: props.label,
        showCancel: false,
        showConfirm: false,
        showExport: false,
        onCancel: resetModalOptions(props),
        startDate: props.startDate,
        endDate: props.endDate,
        eventsCount: props.count,
      })
    }}>
      {props.count}
    </a>
  </div>

export default connect(
  null,
  mergeAll([portfoliosActions, uiActions]),
)(RawCounterBox)



// WEBPACK FOOTER //
// ./src/views/notification-counts/count-box.js